module.exports = __webpack_public_path__ + "static/media/imagen5_2.f658b5da.jpg";